<template>
  <div class="row q-col-gutter-md">
    <div class="col-12 text-h6 text-primary no-grap row">
      <q-icon name="mdi-file-document-edit" color="primary" size="22px" class="q-mr-sm" />
      Aviso de Privacidad
      <q-space />
      <q-btn flat round color="primary" icon="print" @click="exportarPDF()" />
    </div>
    <div class="col-12">
      <q-separator class="bg-primary" />
    </div>
    <div class="col-12">
      <div class="text-bold text-h5 text-center">AVISO DE PRIVACIDAD</div>
      <div class="text-body1 text-justify q-mt-md">
        Los Servicios de Salud del Estado de Durango con domicilio Avenida Cuauhtemoc 225,
        Zona Centro, 34000, Durango, Dgo., es el responsable del tratamiento de los datos
        personales que nos proporcione, los cuales serán protegidos conforme a lo
        dispuesto por la Ley General de Protección de Datos Personales en Posesión de
        Sujetos Obligados, la Ley de Protección de Datos Personales en Posesión de Sujetos
        Obligados del Estado de Durango, y demás normatividad que resulte aplicable.
      </div>
      <div class="text-bold text-h5 text-center q-mt-md">
        FINALIDADES DEL TRATAMIENTO DE LOS DATOS PERSONALES
      </div>
      <div class="text-body1 text-justify q-mt-md">
        Los datos personales que se recaban serán utilizados para las siguientes
        finalidades:
      </div>
      <div class="text-body1 text-justify q-mt-sm q-ml-md">
        • Dar contestación a las solicitudes de Acceso a la Información a través de la
        Plataforma Nacional de Transparencia, con la colaboración de la información
        proporcionada por las diversas áreas de los Servicios de Salud del Estado de
        Durango.
      </div>
      <div class="text-body1 text-justify q-mt-sm q-ml-md">
        • Dar trámite a las denuncias en materia de Transparencia.
      </div>
      <div class="text-body1 text-justify q-mt-sm q-ml-md">
        • Dar respuesta a los recursos de revisión que se notifiquen a la Unidad de
        Transparencia.
      </div>
      <div class="text-body1 text-justify q-mt-sm q-ml-md">
        • Solicitud de derechos ARCO.
      </div>
      <div class="text-body1 text-justify q-mt-sm q-ml-md">
        • Auxiliar a los particulares en la elaboración de solicitudes de acceso a la
        información y en su caso orientarlos sobre los sujetos obligados competentes.
      </div>

      <div class="text-bold text-h5 text-center q-mt-md">
        DATOS PERSONALES QUE SE RECABAN
      </div>

      <div class="text-body1 text-justify q-mt-sm">
        Para las finalidades antes señaladas se solicitarán los siguientes datos
        personales: datos identificativos, datos electrónicos, datos especialmente
        protegidos (sensibles) y datos personales de naturaleza pública. El titular de los
        datos personales no está obligado a proporcionar datos sensibles que hagan
        referencia a la esfera íntima de su persona, tales como origen racial y étnico,
        estado de salud, información genética, creencias religiosas, filosóficas, morales
        y/o preferencias políticas.
      </div>
      <div class="text-bold text-h5 text-center q-mt-md">
        FUNDAMENTO LEGAL PARA EL TRATAMIENTO DE DATOS PERSONALES
      </div>
      <div class="text-body1 text-justify q-mt-sm">
        Los Servicios de Salud del Estado de Durango a través de la Unidad de
        Transparencia, trata los datos personales antes señalados con fundamento en el
        artículo 20 de la Ley Orgánica de la Administración Pública del Estado de Durango
        y demás disposiciones aplicables en la materia.
      </div>
      <div class="text-bold text-h5 text-center q-mt-md">
        TRANSFERENCIA DE DATOS PERSONALES
      </div>
      <div class="text-body1 text-justify q-mt-sm">
        Le informamos que sus datos personales pueden ser compartidos con el Instituto
        Duranguense de Acceso a la Información Pública y de Protección de Datos
        Personales, así como con la Secretaría de Contraloría del Estado de Durango, de
        igual manera con los solicitantes de Información que pueda ser generada por este
        Sujeto Obligado a través de la Plataforma Nacional de Transparencia, para dar
        cumplimiento a la normatividad aplicable en materia de transparencia y acceso a la
        información. Se informa que se realizarán transferencias adicionales, únicamente
        que sean necesarias para atender requerimientos de información de autoridad
        competente, que estén debidamente fundados y motivados.
      </div>
      <div class="text-bold text-h5 text-center q-mt-md">
        EJERCICIO DE LOS DERECHOS ARCO (ACCESO, RECTIFICACIÓN, CANCELACIÓN U OPOSICIÓN DE
        DATOS PERSONALES)
      </div>
      <div class="text-body1 text-justify q-mt-sm">
        El titular de los datos personales o en su caso el representante legal, podrá
        ejercer su derecho de: conocer qué datos personales nos ha proporcionado, para qué
        los utilizamos y las condiciones del uso que les damos (Acceso); de solicitar la
        corrección de su información personal cuando esté incompleta, sea inexacta,
        inadecuada o excesiva (Rectificación); de que se elimine de nuestros registros o
        bases de datos cuando considere que su tratamiento contraviene lo dispuesto por la
        Ley de Protección de Datos Personales en Posesión de los Sujetos Obligados del
        Estado de Durango o porque dejó de ser necesaria para el cumplimiento de la
        finalidado finalidades de dicha base (Cancelación); así como oponerse al uso de
        sus datos personales para fines específicos (Oposición).
      </div>
      <div class="text-body1 text-justify q-mt-sm">
        Es importante señalar que para el ejercicio de los derechos ARCO, el titular podrá
        hacerlo mediante la Plataforma Nacional de Transparencia
        www.plataformadetransparencia.org.mx Los requisitos que debe cumplir para
        presentar una solicitud de Derechos ARCO, son los siguientes: 1. El nombre del
        titular y su domicilio o cualquier otro medio para recibir notificaciones; 2. Los
        documentos que acrediten la identidad del titular y, en su caso, la personalidad e
        identidad de su representante; 3. De ser posible, el área responsable que trata
        los datos personales, y ante el cual se presenta la solicitud; 4. La descripción
        clara y precisa de los datos personales respecto de los que se busca ejercer
        alguno de los derechos ARCO, salvo que se trate del derecho de acceso; 5. La
        descripción del derecho ARCO que se pretende ejercer o, bien, lo que solicita el
        titular, y 6. Cualquier otro elemento o documento que facilite la localización de
        los datos personales, de ser necesario.
      </div>
      <div class="text-body1 text-justify q-mt-sm">
        En caso de solicitar la rectificación, adicionalmente deberá indicar las
        modificaciones a realizarse y aportar la documentación oficial necesaria que
        sustente su petición. En el derecho de cancelación debe expresar las causas que
        motivan la eliminación. Y en el derecho de oposición debe señalar los motivos que
        justifican se finalice el tratamiento de los datos personales y el daño o
        perjuicio que le causaría o, bien, si la oposición es parcial, debe indicar las
        finalidades específicas con las que no está de acuerdo, siempre que no sea un
        requisito obligatorio. La Unidad de Transparencia responderá en el domicilio o
        medio que el titular de los datos personales designe en su solicitud, en un plazo
        de 20 días hábiles, que puede ser ampliado por 10 días hábiles más, previa
        notificación. La respuesta indicará si la solicitud de acceso, rectificación,
        cancelación u oposición es procedente y, en su caso, hará efectivo dentro de los
        15 días hábiles siguientes a la fecha en que comunique la respuesta.
      </div>
      <div class="text-center q-mt-lg">
        <q-img
          src="https://upload.wikimedia.org/wikipedia/commons/7/71/Firma_Josep_Irla.png"
          spinner-color="white"
          style="height: 170px; max-width: 300px"
          img-class="my-custom-image"
          class="rounded-borders"
        >
          <div class="absolute-bottom text-subtitle1 text-center">
            {{
              paciente.nombres +
              " " +
              paciente.apellidoPaterno +
              " " +
              paciente.apellidoMaterno
            }}
          </div>
        </q-img>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import { computed, onBeforeMount } from "vue";
import axios from "axios";
import { generarAvisoPrivacidad } from "../PDF/AvisoPrivacidadPDF.js";
import { Notify, useQuasar, QSpinnerFacebook } from "quasar";
const $q = useQuasar();
const store = useStore();

const paciente = computed({
  get: () => store.state.pacienteStore,
  set: (val) => (store.state.pacienteStore = val),
});

async function exportarPDF() {
  await generarAvisoPrivacidad(paciente.value);
}
</script>
